var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHistoryIcon = function SvgHistoryIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A1A",
    stroke: "#1A1A1A",
    strokeWidth: 0.25,
    d: "M20.715 18.594V16.79a.53.53 0 0 0-.518-.532c-.327 0-.567.268-.567.595v2.477c0 .192.159.35.35.35h1.96c.306 0 .566-.25.556-.557-.01-.321-.274-.528-.595-.528zM8.941 10.372h7.253c.37 0 .667-.303.657-.677a.68.68 0 0 0-.672-.638H8.955a.68.68 0 0 0-.672.624.67.67 0 0 0 .192.499.67.67 0 0 0 .466.192Zm4.802 2.65a.66.66 0 0 0-.658-.658h-4.13a.663.663 0 0 0-.667.595.66.66 0 0 0 .658.715h4.144c.36.01.653-.288.653-.653Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A1A",
    stroke: "#1A1A1A",
    strokeWidth: 0.25,
    d: "M15.325 21.84H7.813a1.037 1.037 0 0 1-1.032-1.033V6.974c0-.567.465-1.032 1.032-1.032h10.805c.566 0 1.032.465 1.032 1.032V12.2a.71.71 0 0 0 .633.71.695.695 0 0 0 .759-.696V6.974a2.43 2.43 0 0 0-2.424-2.43H7.813a2.42 2.42 0 0 0-2.424 2.3v14.098a2.424 2.424 0 0 0 2.424 2.294h7.497c.35 0 .658-.25.706-.595a.7.7 0 0 0-.691-.802Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A1A",
    stroke: "#1A1A1A",
    strokeWidth: 0.25,
    d: "M20.346 13.77a4.74 4.74 0 0 0-4.733 4.77c.019 2.573 2.121 4.676 4.699 4.7a4.74 4.74 0 0 0 4.771-4.733 4.744 4.744 0 0 0-4.737-4.738Zm3.432 4.732a3.436 3.436 0 0 1-3.48 3.432 3.44 3.44 0 0 1-3.384-3.374 3.44 3.44 0 0 1 3.432-3.49 3.434 3.434 0 0 1 3.432 3.432Z"
  })));
};
export default SvgHistoryIcon;